import Http from '@services/httpClient';
import AuthStorage from '../authStorage';

const prefix = '/api/v1';

export default {
  async pushEvent(page: string, action = 'pageview') {
    const isAuthenticated = AuthStorage.getInstance().isAuthenticated();
    if (isAuthenticated) {
      return Http.post({
        url: `${prefix}/event-tracker`,
        data: {
          page,
          action,
        },
      })
        .then((val) => val.data)
        .catch((e) => {
          throw e;
        });
    }

    return Promise.resolve();
  },
};
